<template>
    <div class="newStudentFace">
        <el-row style="margin-top: 50px;">
            <p style="color: #C0C4CC;">请开始人脸识别！</p>
            <el-button type="primary" v-if="!distinguish_show && !liveDetectRecording"
                @click="startLiveDetect">开始识别</el-button>
        </el-row>
        <el-row v-show="distinguish_show || liveDetectRecording"
            style="width: 500px;margin: 0 auto;background-color: #ffffff;margin-top:-50px;">
            <el-row style="text-align: center;margin-top: 10px;">
                <el-row style="text-align: center;padding: 10px;color: #409eff;">
                    <div v-if="liveDetectRecording && currentActionIndex >= 0">
                        <div style="font-size: 18px;font-weight: bold;margin-bottom: 10px;">{{currentActionText}}</div>
                        <div style="font-size: 24px;color: #67C23A;font-weight: bold;">倒计时：{{countdown}}秒</div>
                        <!-- <div style="font-size: 14px;color: #909399;margin-top: 5px;">动作 {{currentActionIndex + 1}} / {{actionList.length}}</div> -->
                    </div>
                    <div v-else>{{tips}}</div>
                </el-row>
                <!-- <el-progress :percentage="percentage" status="success" :color="customColors"></el-progress> -->
                <video id="videoCamera" :width="videoWidth" :height="videoHeight" autoplay></video>
                <canvas style="display:none;" id="canvasCamera" :width="videoWidth" :height="videoHeight"></canvas>
            </el-row>
            <el-row style="text-align: center;">
                <!-- <el-button v-if="liveDetectRecording" type="primary" @click="stopLiveDetectRecording" style="margin-bottom: 10px;">停止录制</el-button> -->
                <el-button type="primary" @click="stopNavigator" style="margin-bottom: 10px;">取消识别</el-button>
            </el-row>
        </el-row>
    </div>
</template>

<script>
    import rzImg from '@/images/user/rz.png';
    import * as faceapi from "face-api.js";
    export default {
        name: "newStudentFace",
        props: {
            verificationTimes: { //验证次数
                type: Number,
                default: 10
            },
            headImg: { // 录取照片
                type: String,
                default: ''
            }
        },
        data() {
            return {
                tag: 1,
                tips: "人脸识别中...",
                rzImg: rzImg,
                distinguish_show: false,
                videoWidth: 400,
                videoHeight: 300,
                imgSrc: '',
                thisCancas: null,
                thisContext: null,
                thisVideo: null,
                setTimeoutInfo: null,
                faceNumber: 0, //控制人脸识别次数
                // 活体检测相关
                liveDetectRecording: false, // 是否正在录制活体检测视频
                liveDetectSessionId: '', // 活体检测会话ID
                liveDetectActionCode: '', // 活体检测动作代码（可能是多个，如"457"、"754"等） 0:眨眼 4:抬头 5:低头 7:左右转头
                mediaRecorder: null, // MediaRecorder实例
                recordedChunks: [], // 录制的视频片段
                videoStream: null, // 视频流
                actionList: [], // 动作列表
                actionCodeList: [], // 动作代码列表，用于播放声音
                currentActionIndex: -1, // 当前动作索引
                currentActionText: '', // 当前动作提示文字
                countdown: 10, // 倒计时（秒）
                countdownTimer: null, // 倒计时定时器
                actionSwitchTimer: null, // 动作切换定时器
                audioMap: { // 动作代码到声音文件的映射
                    '0': require('@/static/voice/qzy.wav'), // 请眨眼
                    '4': require('@/static/voice/qtt.wav'), // 请抬头
                    '5': require('@/static/voice/qdt.wav'), // 请点头
                    '7': require('@/static/voice/zyzt.wav') // 请左右转头
                },
                currentAudio: null // 当前播放的音频对象
            };
        },
        watch: {

        },
        created() {
            let smsVerifyStatus = localStorage.getItem('smsVerifyStatus'); //短信验证通过，直接进入人脸识别
            if(smsVerifyStatus == 1){
                localStorage.removeItem('smsVerifyStatus');
                this.startLiveDetect();
            }
        },
        methods: {
            // 开始活体检测流程
            startLiveDetect() {
                // 先获取活体检测会话ID和动作代码
                this.$store.dispatch("user/getLiveDetectSessionId", {}).then((ret) => {
                    if (ret.code == 0) {
                        this.liveDetectSessionId = ret.data.sessionId;
                        // code可能是数字或字符串，转换为字符串以便处理多个动作代码
                        this.liveDetectActionCode = String(ret.data.code || '');
                        // 根据动作代码设置提示文字
                        this.setLiveDetectTips();
                        // 开始录制视频
                        this.startVideoRecording();
                    } else {
                        this.$message.error(ret.msg || '获取人脸检测信息失败');
                    }
                }).catch((err) => {
                    console.error('获取人脸检测信息失败:', err);
                    this.$message.error('获取人脸检测信息失败');
                });
            },
            // 根据动作代码设置提示文字（支持多个动作代码，如"457"、"754"等）
            setLiveDetectTips() {
                const actionTips = {
                    '0': '请眨眼',
                    '4': '请抬头',
                    '5': '请低头',
                    '7': '请左右转头'
                };

                // 将动作代码字符串拆分成单个字符数组
                const actionCodes = this.liveDetectActionCode.toString().split('');
                // 保存动作代码列表，用于播放声音
                this.actionCodeList = actionCodes.filter(code => actionTips[code]);
                // 根据每个动作代码获取对应的提示文字，生成动作列表
                this.actionList = this.actionCodeList.map(code => actionTips[code]);

                if (this.actionList.length > 0) {
                    // 初始化动作切换
                    this.currentActionIndex = -1;
                    this.countdown = 10;
                } else {
                    this.tips = '请按照提示完成动作';
                }
            },
            // 开始动作切换（每个动作3秒）
            startActionSwitching() {
                if (this.actionList.length === 0) {
                    return;
                }

                // 清除之前的定时器
                this.clearActionTimers();

                // 开始第一个动作
                this.nextAction();
            },
            // 切换到下一个动作
            nextAction() {
                this.currentActionIndex++;

                // 如果所有动作都完成了，保持显示最后一个动作
                if (this.currentActionIndex >= this.actionList.length) {
                    this.currentActionIndex = this.actionList.length - 1;
                    this.currentActionText = this.actionList[this.currentActionIndex];
                    this.countdown = 0;
                    return;
                }

                // 设置当前动作提示
                this.currentActionText = this.actionList[this.currentActionIndex];
                this.countdown = 10; // 重置倒计时

                // 播放当前动作对应的声音
                this.playActionSound();

                // 启动倒计时
                this.startCountdown();

                // 3秒后切换到下一个动作
                this.actionSwitchTimer = setTimeout(() => {
                    this.nextAction();
                }, 10000);
            },
            // 播放动作对应的声音
            playActionSound() {
                // 停止之前播放的音频
                if (this.currentAudio) {
                    this.currentAudio.pause();
                    this.currentAudio.currentTime = 0;
                    this.currentAudio = null;
                }

                // 获取当前动作对应的代码
                if (this.currentActionIndex >= 0 && this.currentActionIndex < this.actionCodeList.length) {
                    const currentActionCode = this.actionCodeList[this.currentActionIndex];
                    const audioPath = this.audioMap[currentActionCode];

                    if (audioPath) {
                        try {
                            this.currentAudio = new Audio(audioPath);
                            this.currentAudio.play().catch(err => {
                                console.error('播放声音失败:', err);
                            });
                        } catch (err) {
                            console.error('创建音频对象失败:', err);
                        }
                    }
                }
            },
            // 启动倒计时
            startCountdown() {
                this.clearCountdownTimer();

                this.countdownTimer = setInterval(() => {
                    this.countdown--;
                    if (this.countdown <= 0) {
                        this.clearCountdownTimer();
                    }
                }, 1000);
            },
            // 清除倒计时定时器
            clearCountdownTimer() {
                if (this.countdownTimer) {
                    clearInterval(this.countdownTimer);
                    this.countdownTimer = null;
                }
            },
            // 清除动作切换定时器
            clearActionTimers() {
                this.clearCountdownTimer();
                if (this.actionSwitchTimer) {
                    clearTimeout(this.actionSwitchTimer);
                    this.actionSwitchTimer = null;
                }
            },
            // 开始录制视频
            startVideoRecording() {
                this.liveDetectRecording = true;
                var _this = this;
                this.thisVideo = document.getElementById('videoCamera');

                // 旧版本浏览器可能根本不支持mediaDevices，我们首先设置一个空对象
                if (navigator.mediaDevices === undefined) {
                    navigator.mediaDevices = {}
                }
                // 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
                // 使用getUserMedia，因为它会覆盖现有的属性。
                // 这里，如果缺少getUserMedia属性，就添加它。
                if (navigator.mediaDevices.getUserMedia === undefined) {
                    navigator.mediaDevices.getUserMedia = function(constraints) {
                        // 首先获取现存的getUserMedia(如果存在)
                        var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator
                            .getUserMedia
                        // 有些浏览器不支持，会返回错误信息
                        // 保持接口一致
                        if (!getUserMedia) {
                            return Promise.reject(new Error('getUserMedia is not implemented in this browser'))
                        }
                        // 否则，使用Promise将调用包装到旧的navigator.getUserMedia
                        return new Promise(function(resolve, reject) {
                            getUserMedia.call(navigator, constraints, resolve, reject)
                        });
                    }
                }

                var constraints = {
                    audio: false,
                    video: {
                        width: this.videoWidth,
                        height: this.videoHeight,
                        transform: 'scaleX(-1)'
                    }
                }
                navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
                    this.videoStream = stream;
                    // 旧的浏览器可能没有srcObject
                    if ('srcObject' in _this.thisVideo) {
                        _this.thisVideo.srcObject = stream
                    } else {
                        // 避免在新的浏览器中使用它，因为它正在被弃用。
                        _this.thisVideo.src = window.URL.createObjectURL(stream)
                    }
                    _this.thisVideo.onloadedmetadata = function(e) {
                        _this.thisVideo.play();
                        // 开始动作切换（每个动作3秒）
                        _this.startActionSwitching();
                        // 开始录制视频
                        _this.startRecording(stream);
                    }
                }).catch(err => {
                    console.error('获取摄像头失败:', err);
                    this.$message.error('获取摄像头失败，请检查权限设置');
                    this.liveDetectRecording = false;
                });
            },
            // 开始录制
            startRecording(stream) {
                try {
                    this.recordedChunks = [];
                    // 使用 webm 格式，兼容性较好
                    const options = {
                        mimeType: 'video/webm;codecs=vp8'
                    };
                    if (!MediaRecorder.isTypeSupported(options.mimeType)) {
                        // 如果不支持，尝试其他格式
                        options.mimeType = 'video/webm';
                    }
                    this.mediaRecorder = new MediaRecorder(stream, options);

                    this.mediaRecorder.ondataavailable = (event) => {
                        if (event.data && event.data.size > 0) {
                            this.recordedChunks.push(event.data);
                        }
                    };

                    this.mediaRecorder.onstop = () => {
                        this.submitLiveDetectVideo();
                    };

                    // 开始录制
                    this.mediaRecorder.start();
                    // 根据动作数量动态设置录制时间：每个动作3秒，至少10秒，最多30秒（防止文件过大）
                    const recordDuration = Math.max(10000, Math.min(35000, this.actionList.length * 10000 +
                    1000)); // 每个动作3秒，额外1秒缓冲
                    console.log(recordDuration)
                    setTimeout(() => {
                        if (this.mediaRecorder && this.mediaRecorder.state === 'recording') {
                            this.mediaRecorder.stop();
                        }
                    }, recordDuration);
                } catch (err) {
                    console.error('开始录制失败:', err);
                    this.$message.error('开始录制失败');
                    this.stopLiveDetectRecording();
                }
            },
            // 停止录制
            stopLiveDetectRecording() {
                // 清除动作切换定时器
                this.clearActionTimers();

                // 停止播放音频
                if (this.currentAudio) {
                    this.currentAudio.pause();
                    this.currentAudio.currentTime = 0;
                    this.currentAudio = null;
                }

                if (this.mediaRecorder && this.mediaRecorder.state === 'recording') {
                    this.mediaRecorder.stop();
                }
                if (this.videoStream) {
                    this.videoStream.getTracks().forEach(track => track.stop());
                    this.videoStream = null;
                }
                this.liveDetectRecording = false;
                // 重置动作相关状态
                this.currentActionIndex = -1;
                this.countdown = 10;
            },
            // 提交活体检测视频
            submitLiveDetectVideo() {
                if (this.recordedChunks.length === 0) {
                    this.$message.error('录制失败，请重试');
                    this.stopLiveDetectRecording();
                    return;
                }

                const blob = new Blob(this.recordedChunks, {
                    type: 'video/webm'
                });
                // 检查文件大小，限制不超过10MB
                if (blob.size > 10 * 1024 * 1024) {
                    this.$message.error('视频文件过大，请重新录制（不超过10MB）');
                    this.stopLiveDetectRecording();
                    return;
                }

                this.tips = '正在提交人脸检测信息...';

                const formData = new FormData();
                formData.append('video', blob, 'liveDetect.webm');
                formData.append('sessionId', this.liveDetectSessionId);
                const loading = this.$loading({
                    lock: true,
                    text: '人脸信息提交中......',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$store.dispatch("user/liveDetect", {
                    formData: formData
                }).then((ret) => {
                    loading.close();
                    if (ret.code == 0) {
                        // 活体检测通过，使用返回的 bestPic 进行人脸识别
                        const bestPic = ret.data.bestPic;
                        if (bestPic) {
                            this.imgSrc = "data:image/jpeg;base64," + bestPic;
                            // 停止视频流
                            if (this.videoStream) {
                                this.videoStream.getTracks().forEach(track => track.stop());
                                this.videoStream = null;
                            }
                            this.liveDetectRecording = false;
                            // 开始人脸识别
                            this.distinguish_show = true;
                            this.tips = '检测通过，开始人脸识别...';
                            this.getFace();
                        } else {
                            this.$message.error('人脸检测失败：未获取到有效图片');
                            this.stopLiveDetectRecording();
                        }
                    } else {
                        this.$message.error(ret.data || ret.msg || '人脸检测失败');
                        this.stopLiveDetectRecording();
                    }
                }).catch((err) => {
                    loading.close();
                    console.error('提交人脸检测失败:', err);
                    this.$message.error('提交人脸检测失败');
                    this.stopLiveDetectRecording();
                });
            },
            getCompetence() { //开始人脸识别（保留原方法，但不再直接调用）
                this.faceNumber = 0;
                this.distinguish_show = true;
                var _this = this;
                this.thisCancas = document.getElementById('canvasCamera')
                this.thisContext = this.thisCancas.getContext('2d')
                this.thisVideo = document.getElementById('videoCamera')
                // 旧版本浏览器可能根本不支持mediaDevices，我们首先设置一个空对象
                if (navigator.mediaDevices === undefined) {
                    navigator.mediaDevices = {}
                }
                // 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
                // 使用getUserMedia，因为它会覆盖现有的属性。
                // 这里，如果缺少getUserMedia属性，就添加它。
                if (navigator.mediaDevices.getUserMedia === undefined) {
                    navigator.mediaDevices.getUserMedia = function(constraints) {
                        // 首先获取现存的getUserMedia(如果存在)
                        var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator
                            .getUserMedia
                        // 有些浏览器不支持，会返回错误信息
                        // 保持接口一致
                        if (!getUserMedia) {
                            return Promise.reject(new Error('getUserMedia is not implemented in this browser'))
                        }
                        // 否则，使用Promise将调用包装到旧的navigator.getUserMedia
                        return new Promise(function(resolve, reject) {
                            getUserMedia.call(navigator, constraints, resolve, reject)
                        });
                    }
                }
                var constraints = {
                    audio: false,
                    video: {
                        width: this.videoWidth,
                        height: this.videoHeight,
                        transform: 'scaleX(-1)'
                    }
                }
                navigator.mediaDevices.getUserMedia(constraints).then(function(stream) {
                    // 旧的浏览器可能没有srcObject
                    if ('srcObject' in _this.thisVideo) {
                        _this.thisVideo.srcObject = stream
                    } else {
                        // 避免在新的浏览器中使用它，因为它正在被弃用。
                        _this.thisVideo.src = window.URL.createObjectURL(stream)
                    }
                    _this.thisVideo.onloadedmetadata = function(e) {
                        _this.thisVideo.play();
                        setTimeout(() => {
                            _this.setImage();
                        }, 500);
                    }
                }).catch(err => {
                    console.log(err)
                });
            },
            //  绘制图片（拍照功能）
            setImage() {
                var _this = this
                // 点击，canvas画图
                _this.thisContext.drawImage(_this.thisVideo, 0, 0, _this.videoWidth, _this.videoHeight)
                // 获取图片base64链接
                var image = this.thisCancas.toDataURL('image/png')
                _this.imgSrc = image;
                this.getFace(); //调用人脸识别接口对比
            },
            // base64转文件
            dataURLtoFile(dataurl, filename) {
                var arr = dataurl.split(',')
                var mime = arr[0].match(/:(.*?);/)[1]
                var bstr = atob(arr[1])
                var n = bstr.length
                var u8arr = new Uint8Array(n)
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n)
                }
                return new File([u8arr], filename, {
                    type: mime
                })
            },
            // 关闭摄像头 取消人脸识别
            stopNavigator() {
                this.clearTime();
                this.distinguish_show = false;
                // 停止活体检测录制
                if (this.liveDetectRecording) {
                    this.stopLiveDetectRecording();
                }
                if (this.thisVideo != null && this.thisVideo.srcObject) {
                    this.thisVideo.srcObject.getTracks().forEach(track => track.stop());
                }
                if (!this.$isEmpty(this.setTimeoutInfo)) {
                    clearTimeout(this.setTimeoutInfo);
                }
            },
            getFace() { // 百度人脸识别接口
                this.$store.dispatch("user/studentNewFace", {
                    image: this.imgSrc
                }).then((ret) => {
                    if (ret.code == 0) {
                        // 停止视频流（如果存在）
                        if (this.thisVideo && this.thisVideo.srcObject) {
                            this.thisVideo.srcObject.getTracks().forEach(track => track.stop());
                        }
                        this.distinguish_show = false;
                        this.$message({
                            message: "人脸识别成功！",
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.$emit("successFace");
                            }
                        });
                    } else {
                        // 判断是否是人脸相似度低于阈值的情况
                        if (ret.msg && ret.msg.indexOf('人脸相似度低于') >= 0) {
                            // 停止摄像头
                            if (this.thisVideo && this.thisVideo.srcObject) {
                                this.thisVideo.srcObject.getTracks()[0].stop();
                            }
                            this.distinguish_show = false;
                            // 触发失败事件，传递失败信息
                            // 从多个可能的位置获取相似度：ret.data.faceScore、ret.faceScore 或从 msg 中提取
                            let faceScore = '';
                            if (ret.faceScore !== null) {
                                faceScore = ret.faceScore;
                            } else {
                                faceScore = this.extractSimilarity(ret.msg);
                            }
                            this.$emit("faceFailed", {
                                msg: ret.msg,
                                faceScore: faceScore,
                                originalImage: (ret.data && ret.data.originalImage) || ret
                                    .originalImage || this.headImg, // 录取照片
                                targetPhotoUrl: ret.data && ret.data.targetPhotoUrl || ret
                                    .targetPhotoUrl || this.imgSrc, // 采集图像（targetPhotoUrl）
                                capturedImage: this.imgSrc, // 保留兼容性
                                data: ret.data || {}
                            });
                            return;
                        } else {
                            this.$emit("faceFailed", {
                                msg: ret.msg,
                                faceScore: null,
                                originalImage: (ret.data && ret.data.originalImage) || ret
                                    .originalImage || this.headImg, // 录取照片
                                targetPhotoUrl: ret.data && ret.data.targetPhotoUrl || ret
                                    .targetPhotoUrl || this.imgSrc, // 采集图像（targetPhotoUrl）
                                capturedImage: this.imgSrc, // 保留兼容性
                                data: ret.data || {}
                            });
                        }
                        this.faceNumber++;
                        if (this.faceNumber >= 6) { //连续人脸识别6次都失败则退出人脸识别
                            this.stopNavigator();
                            return;
                        }
                        this.$message({
                            message: ret.msg,
                            type: 'warning'
                        });
                        this.setTimeoutInfo = setTimeout(() => {
                            this.setImage();
                        }, 5000);
                    }
                })
            },
            clearTime() {
                if (!this.$isEmpty(this.setTimeoutInfo)) {
                    clearTimeout(this.setTimeoutInfo);
                }
            },
            // 从msg中提取相似度数值
            extractSimilarity(msg) {
                if (!msg) return '';
                // 匹配"人脸相似度低于85.0"中的85.0，支持多种格式
                const patterns = [
                    /人脸相似度低于([\d.]+)/,
                    /相似度[为是]([\d.]+)/,
                    /([\d.]+)%/
                ];
                for (let pattern of patterns) {
                    const match = msg.match(pattern);
                    if (match && match[1]) {
                        return match[1];
                    }
                }
                return '';
            }
        },
        beforeDestroy() {
            this.clearTime();
            this.stopNavigator();
            // 清理活体检测相关资源
            this.clearActionTimers();
            // 停止播放音频
            if (this.currentAudio) {
                this.currentAudio.pause();
                this.currentAudio.currentTime = 0;
                this.currentAudio = null;
            }
            if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
                this.mediaRecorder.stop();
            }
            if (this.videoStream) {
                this.videoStream.getTracks().forEach(track => track.stop());
            }
        },
    };
</script>

<style scoped>
    .newStudentFace {
        .see {
            position: relative;
        }

        .see canvas {
            position: absolute;
            top: 0;
            left: 0;
        }

        .option {
            padding-bottom: 20px;
        }

        .option div {
            padding: 10px;
            border-bottom: 2px #42b983 solid;
        }

        .option div label {
            margin-right: 20px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/newStudentFace.vue